import { Fragment } from "react";
//* import global component

import FormControl from "../UI/FormControl";
//* import styles
import styles from "./SignUpForm.module.css";
//TODO this contains just two form controls
const SignUpForm1 = (props) => {
  const { formState, onDispatchForm } = props;
  const {
    lastNameIsValid,
    firstNameIsValid,
    error,
  } = formState;
  const changeLastNameHandler = (event) => {
    const value = event.target.value;
    onDispatchForm({
      type: "LASTNAME_INPUT",
      value,
    });
  };
  const changeFirstNameHandler = (event) => {
    const value = event.target.value;
    onDispatchForm({
      type: "FIRSTNAME_INPUT",
      value,
    });
  };
  return (
    <Fragment>
      <div className={styles["form-controls"]}>
        <FormControl
          error={error.lastNameError}
          errorClassName={styles["error"]}
          Input={{
            type: "text",
            id: "lastname",
            value: formState.lastNameValue,
            onChange: changeLastNameHandler,
            // onBlur: blurInputHandler,
          }}
          Label={{
            child: { label: "Lastname" },
            properties: {
              htmlFor: "lastname",
            },
          }}
          className={`${styles["form-control"]}
            ${
              lastNameIsValid
                ? ""
                : styles["invalid"]
            }`}
        />
      </div>
      <div className={styles["form-controls"]}>
        <FormControl
          error={error.firstNameError}
          errorClassName={styles["error"]}
          Input={{
            type: "text",
            id: "firstname",
            value: formState.firstNameValue,
            onChange: changeFirstNameHandler,
            // onBlur: blurInputHandler,
          }}
          Label={{
            child: { label: "Firstname" },
            properties: {
              htmlFor: "firstname",
            },
          }}
          className={`${styles["form-control"]}
            ${
              firstNameIsValid
                ? ""
                : styles["invalid"]
            }`}
        />
      </div>
    </Fragment>
  );
};

export default SignUpForm1;
